import React from "react";
import styled from "styled-components";
import { Flex, Text } from "../../assets/ui";
import Theme from "../../assets/ui/theme";

const OpenApp = styled.button`
  background: #ed3163;
  border-radius: 26px;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  text-transform: uppercase;
  padding: 16px 20px;
  color: #ffffff;
`;
const StyledSectionWrapper = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 190px;
  border-top: 1px solid rgba(58, 79, 106, 0.2);
  border-bottom: 1px solid rgba(58, 79, 106, 0.2);
  background: url("./images/give-up-line-bg.png") no-repeat;
  background-position: bottom;
  background-size: auto 220px;

  @media (min-width: ${({ theme }) => theme.queries.sl}) {
    background-size: 100% auto;
  }
`;

const GiveUp = () => {
  return (
    <StyledSectionWrapper>
      <Text
        fontSize={["14px"]}
        lineHeight={["17px"]}
        color={Theme.colors.subTitle}
        marginBottom={["15px"]}
      >
        Open application
      </Text>
      <Text
        fontSize={["28px", null, "48px"]}
        lineHeight={["35px", null, "59px"]}
        color={Theme.colors.darkBlue}
        textAlign="center"
        maxWidth="510px"
        fontWeight="bold"
        marginBottom={["32px", null, "36px"]}
      >
        Nothing fits you?  <br /> Don’t give up too easy!
      </Text>
      <Text
        fontSize={["16px", null, "18px"]}
        lineHeight={["18px", null, "24px"]}
        color={Theme.colors.descriptionText}
        textAlign="center"
        maxWidth="420px"
        // fontWeight="bold"
        marginBottom={["56px", null, "60px"]}
      >
        If we’re not hiring for your position, or you have diverse skills that
        fit under many job titles, send an open application instead.
      </Text>
      <OpenApp>Get in touch</OpenApp>
    </StyledSectionWrapper>
  );
};

export default GiveUp;
